var map = {
	"./carbon-icon.svg": 1790,
	"./dff-icon.svg": 186,
	"./ffb-icon.svg": 136,
	"./fff-icon.svg": 185,
	"./ffi-icon.svg": 137,
	"./gef-icon.svg": 187,
	"./gff-icon.svg": 188,
	"./pff-icon.svg": 189,
	"./tff-icon.svg": 159,
	"./wff-icon.svg": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1789;